import { format, getHours } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
  
  const formatDate = (date, horInicio) => {

    const newDate = new Date(date)
    const newIn  = new Date(horInicio)

    if (getHours(newDate) === getHours(newIn)) {
      return format(newDate, 'dd/MM/yyyy HH:mm', { locale: ptBR });
    } else {
      return format(newDate, 'hh:mm', { locale: ptBR });
    }
  }

export default formatDate;